var path = '/common/component/tpl/video-youtube.html';
var html = "<div class=\"media youtube-container\"> <div class=\"yt-wrap yt-responsive\"> <a ng-click=showVideo($event) ng-show=!$ctrl.active ng-style=$ctrl.placeholderStyle class=yt-placeholder> <i class=yt-btn></i> </a> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/common/component/tpl/video-youtube.html
// module id = 303
// module chunks = 0 1 2 3 4